import { useNode } from "@craftjs/core";
import React from "react";

import { UnitInput, MarginInput, Spacer, Tabs, Panel } from "../../input";
import { supportLibrary } from "../../block-supports";
import { isUpdatedFromDefault } from "../../utils";

export const SpacerSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
    dom,
    supports,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
    dom: node.dom,
    supports: node.data?.type?.craft?.related?.supports,
  }));

  const {
    width = "100%",
    widthTablet,
    widthMobile,
    height = "100px",
    heightTablet,
    heightMobile,
    maxWidth,
    maxWidthTablet,
    maxWidthMobile,
    maxHeight,
    maxHeightTablet,
    maxHeightMobile,
    minWidth,
    minWidthTablet,
    minWidthMobile,
    minHeight,
    minHeightTablet,
    minHeightMobile,
    margin,
    marginTablet,
    marginMobile,
  } = props;

  function GeneralSettings() {
    return (
      <>
        <div className="g-settings__wrapper">
          <Spacer spacing="1rem">
            <UnitInput
              resetValue={"100%"}
              auto
              isResponsive={true}
              valueTablet={widthTablet}
              valueMobile={widthMobile}
              value={width}
              onChange={(val) => {
                setProp((props) => {
                  props.width = val;
                });
              }}
              setValueTablet={(val) => {
                setProp((props) => {
                  props.widthTablet = val;
                });
              }}
              setValueMobile={(val) => {
                setProp((props) => {
                  props.widthMobile = val;
                });
              }}
              label={"Width"}
            />
            <UnitInput
              resetValue={"100px"}
              auto
              isResponsive={true}
              valueTablet={heightTablet}
              valueMobile={heightMobile}
              value={height}
              onChange={(val) => {
                setProp((props) => {
                  props.height = val;
                });
              }}
              setValueTablet={(val) => {
                setProp((props) => {
                  props.heightTablet = val;
                });
              }}
              setValueMobile={(val) => {
                setProp((props) => {
                  props.heightMobile = val;
                });
              }}
              label={"Height"}
            />
            <UnitInput
              isResponsive={true}
              valueTablet={maxHeightTablet}
              valueMobile={maxHeightMobile}
              resetValue={undefined}
              value={maxHeight}
              onChange={(val) => {
                setProp((props) => {
                  props.maxHeight = val;
                });
              }}
              setValueTablet={(val) => {
                setProp((props) => {
                  props.maxHeightTablet = val;
                });
              }}
              setValueMobile={(val) => {
                setProp((props) => {
                  props.maxWidthMobile = val;
                });
              }}
              label={"Max Height"}
            />
            <UnitInput
              isResponsive={true}
              valueTablet={maxWidthTablet}
              valueMobile={maxWidthMobile}
              resetValue={undefined}
              value={maxWidth}
              onChange={(val) => {
                setProp((props) => {
                  props.maxWidth = val;
                });
              }}
              setValueTablet={(val) => {
                setProp((props) => {
                  props.maxWidthTablet = val;
                });
              }}
              setValueMobile={(val) => {
                setProp((props) => {
                  props.maxWidthMobile = val;
                });
              }}
              label={"Max Width"}
            />
            <UnitInput
              isResponsive={true}
              valueTablet={minHeightTablet}
              valueMobile={minHeightMobile}
              resetValue={undefined}
              value={minHeight}
              onChange={(val) => {
                setProp((props) => {
                  props.minHeight = val;
                });
              }}
              setValueTablet={(val) => {
                setProp((props) => {
                  props.minHeightTablet = val;
                });
              }}
              setValueMobile={(val) => {
                setProp((props) => {
                  props.minHeightMobile = val;
                });
              }}
              label={"Min Height"}
            />
            <UnitInput
              isResponsive={true}
              valueTablet={minWidthTablet}
              valueMobile={minWidthMobile}
              resetValue={undefined}
              value={minWidth}
              onChange={(val) => {
                setProp((props) => {
                  props.minWidth = val;
                });
              }}
              setValueTablet={(val) => {
                setProp((props) => {
                  props.minWidthTablet = val;
                });
              }}
              setValueMobile={(val) => {
                setProp((props) => {
                  props.minWidthMobile = val;
                });
              }}
              label={"Min Width"}
            />
          </Spacer>
        </div>
      </>
    );
  }
  function AdvancedSettings() {
    return (
      <>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: marginTablet },
            { key: marginMobile },
            { key: margin },
          ])}
          id={`block-setting-${id}-layout`}
          title={"Layout"}
          initialOpen={true}
        >
          <MarginInput
            isResponsive={true}
            valueTablet={marginTablet}
            valueMobile={marginMobile}
            resetValue={undefined}
            value={margin}
            onChange={(val) => {
              setProp((props) => {
                props.margin = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.marginTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.marginMobile = val;
              });
            }}
            label={"Margin"}
          />
        </Panel>
        {supports &&
          supports.map((support) => {
            var Component = supportLibrary[support]?.component;

            if (!Component) {
              return;
            }

            return (
              <>
                <Component
                  block={{
                    id,
                    props,
                    dom,
                  }}
                  actions={{
                    setProp,
                  }}
                ></Component>
              </>
            );
          })}
      </>
    );
  }
  const tabs = [
    {
      label: "General",
      key: "general",
      children: GeneralSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: width },
        { key: widthTablet },
        { key: widthMobile },
        { key: height },
        { key: heightTablet },
        { key: heightMobile },
        { key: maxWidth },
        { key: maxWidthTablet },
        { key: maxWidthMobile },
        { key: maxHeight },
        { key: maxHeightTablet },
        { key: maxHeightMobile },
        { key: minWidth },
        { key: minWidthTablet },
        { key: minWidthMobile },
        { key: minHeight },
        { key: minHeightTablet },
        { key: minHeightMobile },
      ]),
    },
    {
      label: "Advanced",
      key: "advanced",
      children: AdvancedSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: margin },
        { key: marginTablet },
        { key: marginMobile },
      ]),
    },
  ];

  return (
    <div>
      <Tabs type="block-setting" id={`block-settings-tab-${id}`} items={tabs} />
    </div>
  );
};
